export type StyleObj = Record<string, number | string | null>
export type ModalStyle = {
  overlay: StyleObj
  content: StyleObj
}
const defaultModalStyles: ModalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: '1rem',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    overflow: 'auto',
    zIndex: 101,
  },
  content: {
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    border: 0,
    borderRadius: '3px',
    padding: null,
    maxWidth: '1120px',
    backgroundColor: 'var(--gray-1)',
    boxShadow: 'var(--shadow-4)',
    // don't set overflow here, set it where you really need it
    // note: `overflow: auto` (react-modal default) clips (cuts) dropdowns
    overflow: 'visible',
    margin: '30px auto auto',
  },
}
export default defaultModalStyles
export const compactModalStyles: ModalStyle = {
  ...defaultModalStyles,
  content: { ...defaultModalStyles.content, maxWidth: '400px' },
}
export const pricingModalStyles: ModalStyle = {
  ...defaultModalStyles,
  content: { ...defaultModalStyles.content, maxWidth: '70rem' },
}
export const overflownModalStyles: ModalStyle = {
  ...defaultModalStyles,
  content: { ...defaultModalStyles.content, overflow: 'visible' },
}
export const doubleScrollModalStyles: ModalStyle = {
  ...defaultModalStyles,
  content: {
    ...defaultModalStyles.content,
    overflow: 'initial',
    margin: '0 auto auto',
  },
}
// alignTopModalStyles is deprecated 2019-08-20
export const alignTopModalStyles: ModalStyle = defaultModalStyles
export const modalWindowStyles: ModalStyle = {
  overlay: {
    ...defaultModalStyles.overlay,
    flexDirection: 'column',
    overflow: 'hidden',
    // First sidebar menu item top offset
    padding: '66px',
  },
  content: {
    ...defaultModalStyles.content,
    backgroundColor: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    margin: 0,
    maxHeight: '100%',
    maxWidth: '100%',
    padding: 0,
  },
}
export const videoModalStyles: ModalStyle = {
  overlay: {
    position: 'fixed',
    top: 'auto',
    right: '4rem',
    bottom: '3.5rem',
    left: 'auto',
    backgroundColor: 'transparent',
    zIndex: 104,
    width: '33%',
    minWidth: '430px',
  },
  content: {
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    border: 0,
    borderRadius: 0,
    padding: 0,
    background: 'none',
    overflow: 'none',
  },
}
export const publicPlaylistDefaultModalStyles: ModalStyle = {
  ...defaultModalStyles,
  overlay: { ...defaultModalStyles.overlay, position: 'fixed' },
  content: { ...defaultModalStyles.content, padding: '2rem' },
}
export const publicPlaylistVideoModalStyles: ModalStyle = {
  overlay: {
    ...defaultModalStyles.overlay,
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    zIndex: 104,
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    ...defaultModalStyles.content,
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    border: 0,
    padding: 0,
    maxWidth: '60rem',
    margin: 'auto',
    overflow: 'visible',
  },
}
export const hamburgerModalStyles: ModalStyle = {
  overlay: {
    // position: 'absolute',
    backgroundColor: 'transparent',
    zIndex: 102,
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    position: 'absolute',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    overflow: 'initial',
    left: 'auto',
    transform: 'translate(calc(-100% + 0.5rem), 1rem)',
    padding: '8px 0',
    border: 0,
    backgroundColor: '#fff',
    borderRadius: 3,
    boxShadow:
      '0 0 0 1px rgba(6, 44, 82, 0.1), 0 2px 16px 0 rgba(33, 43, 54, 0.08)',
  },
}
export const darkThemeModalStyles = {
  overlay: {
    ...defaultModalStyles.overlay,
    background: 'rgba(0, 0, 0, 0.54)',
  },
  content: {
    ...defaultModalStyles.content,
    border: '1px solid var(--gray-12)',
    borderRadius: '3px',
    overflow: 'auto',
    backgroundColor: 'var(--gray-12)',
    boxShadow: 'var(--shadow-4)',
  },
}
export const mobileModalAdditionalStyles = {
  overlay: {
    padding: '20px',
  },
  content: {
    maxWidth: 'calc(100vw - 40px)',
    marginTop: '0px',
  },
}

export const containedModalStyles: ModalStyle = {
  ...defaultModalStyles,
  content: {
    ...defaultModalStyles.content,
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    overflow: 'auto',
    height: 'fit-content',
    maxHeight: 'calc(100vh - 50px - var(--player-active-offset, 0px))',
    margin: '0 auto auto',
    scrollbarWidth: 'thin',
  },
}

export const rightsDataModalStyles: ModalStyle = {
  overlay: {
    ...defaultModalStyles.overlay,
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px',
    overflow: 'hidden',
  },
  content: {
    ...defaultModalStyles.content,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '800px',
    width: '95%',
    minHeight: '240px',
    margin: '0',
    overflow: 'hidden',
  },
}
